export function SET_FILTERS({ commit }, [favorite, progress, search, selected_areas, subscription_type, selected_categories, selected_tags, selected_groups ]) {
    commit('SAVE_FILTERS', [favorite, progress, search, selected_areas, subscription_type, selected_categories, selected_tags, selected_groups])
}

export function SET_PROGRESS({ commit }, progress) {
    commit('SAVE_PROGRESS', progress)
}

export function SET_FILTER_AREA({ commit }, selected_areas) {
    commit('SAVE_FILTER_AREA', selected_areas)
}

export function SET_LOADING({ commit }, loading) {
    commit('SAVE_LOADING', loading)
}

export function SET_FILTERS_CATEGORY({ commit }, [selected_categories]) {
	commit('SAVE_FILTERS_CATEGORY', [selected_categories])
}